import * as React from 'react';

import { TMessage } from '../../../../types/messages';
import { BubbleMessageContainer } from '../../../BubbleMessageContainer';

interface IBubblesContainerProps {
  message: TMessage;
  messageId: string;
}

export const BubblesContainer: React.FC<IBubblesContainerProps> = ({ message, messageId }) => {
  const { bubbles } = message;

  if (!bubbles?.length) {
    return null;
  }

  return (
    <>
      {bubbles.map((bubble, index) => (
        <BubbleMessageContainer key={`${bubble.title.label}-${index}`} bubble={bubble} messageId={messageId} />
      ))}
    </>
  );
};
